import {reqPackageCodes,} from "../api";

export const SECRET_KEY = 'K0d3ry7f!ZW9qA4f';//中欧特快秘钥
export const SECRET_KEY_M = 'LJ7iL!z$#WyeWrP7';//满欧快线秘钥
export const PATH_NAME = {
    /*
     '/': '订单管理',
     '/goodsList': '货物管理',
     '/trackList': '物流信息管理',
     */
};
export const ORDER_STATUS = {
    audit: '待审核',
    audited: '待订舱',
    booked: '已订舱',
    boxed: '已装箱',
    declare: '待报关',
    declaring: '报关中',
    released: '已放行',
    cancelled: '已取消'
};
export const LOGISTICS_STATUS = {
    waiting: "待提货",
    transport: '运输中',
    boxed: '已装箱',
    declaring: '报关中',
    released: '已放行',
    destination: '已到达',
    cancelled: '已取消'
};
export const DEFAULT_CUSTOMS_CODE = {
    N: 'Alashankou', T: 'Khorgos', G: 'GanZhou', M: 'Manchuria', X: 'Urumqi', K: 'Kashgar', Z: 'Khorgos', A: 'Khorgos',
    D: 'Khorgos'
};
export const DEFAULT_CUSTOMS_NAME = {
    N: '阿拉山口', T: '霍尔果斯', G: '赣州', M: '满洲里', X: '乌鲁木齐', K: '喀什(卡拉苏)', Z: '霍尔果斯', A: '霍尔果斯',
    D: '霍尔果斯'
};

export const DELIVERY_TYPE = {
    Z: '霍欧中铁班车', T: '中欧特快', D: '亚欧直达', A: '中哈欧空运', N: '公铁联运', K: '南疆快线', X: '新疆班列',
    /* M: '满欧快线', G: '赣州班列'*/
};
//运输类型：既有公路又有铁路(不含亚欧直达、新疆班列)
export const TRAIN_PORT_DELIVERY_TYPE = {Z: '霍欧中铁班车', N: '公铁联运'};
//运输类型：既有公路又有铁路
export const DELIVERY_TYPE_MIX = {Z: '霍欧中铁班车', D: '亚欧直达', N: '公铁联运', /* G: '赣州班列'*/X: '新疆班列'};
//运输类型：仅公路
export const DELIVERY_TYPE_HIGHWAY = {T: '中欧特快', K: '南疆快线', /*M: '满欧快线'*/};
//运输类型：含空运
export const DELIVERY_TYPE_AIR = {A: '中哈欧空运'};
//特快的一箱到底A 跟公铁联运很像
export const SUB_TYPE = {A: '一箱到底', B: '倒装运输'};
export const TRANSFER_TYPE_N = {w2w: '仓到仓', w2s: '仓到站', s2s: '站到站', s2w: '站到仓'};//DELIVERY_TYPE_MIX除了D
export const TRANSFER_TYPE_D = {w2w: '仓到仓', w2s: '仓到站', p2s: '口岸到站', p2w: '口岸到仓'};//DELIVERY_TYPE=D
export const TRANSFER_TYPE_T = {w2w: '仓到仓', w2p: '仓到口岸', p2p: '口岸服务', s2w: '口岸到仓'};
export const TRANSFER_TYPE_A = {
    w2w: '仓到仓',
    w2as: '仓到启运机场',
    w2a: '仓到目的机场',
    p2p: '口岸服务',
    p2as: '口岸到启运机场',
    p2a: '口岸到目的机场',
    p2w: '口岸到仓'
};
//包装类型
//export const PACKAGE_TYPE = {EC: 'EC (塑料袋)', CT: 'CT (硬纸板盒子)', '5H': '5H (聚合编织袋)',};
const getPackageCodesData = async () => {
    let result = await reqPackageCodes();
    if (result.code === 200) {
        const data = {};
        result.data.forEach((o) => {
            data[o.packageType] = o.packageTypeName;
        });
        return data
    }
    return null
};
export let PACKAGE_TYPE = {};
export const getPackageCodes = () => {
    getPackageCodesData().then(res => {
        if (res != null) {
            PACKAGE_TYPE = res
        }
    })
};
//刷新会重新获取
getPackageCodes();